import { render, staticRenderFns } from "./stock-create-page.vue?vue&type=template&id=7f94c5f8&"
import script from "./stock-create-page.vue?vue&type=script&lang=ts&"
export * from "./stock-create-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports